// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@guestsupply/XDL/Utilities";
import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";
import { css } from "styled-components";

changePasswordActionsStyles.saveButton = {
    css: css`
        width: auto;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

changePasswordActionsStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        width: auto;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

changePasswordActionsStyles.buttonGridContainer = {
    gap: 20,
    offsetCss: css`
        display: flex;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
        }
    `,
};

changePasswordActionsStyles.buttonGridItem = {
    width: 12,
    css: css`
        ${xScreen("gt", "xs")} {
            flex-basis: max-content;
        }
    `,
};
